import React from "react";

const SECTIONS = [
  {
    eyebrow: "The Sea",
    title: "An eastern shore.",
    image: "https://images.pexels.com/photos/8003036/pexels-photo-8003036.jpeg?w=1800&q=80",
    body: "Latvia sits on the eastern shore of the Baltic Sea — a brackish, cold, slow sea ringed by pine forests and white sand dunes. The coast at Jūrmala stretches for thirty-three kilometres. In the early morning, before the sun is fully up, you can walk it alone for an hour and meet no one but the gulls.",
  },
  {
    eyebrow: "The Amber Road",
    title: "Traded to Rome, Egypt, the Silk Road.",
    image: "https://images.pexels.com/photos/18730034/pexels-photo-18730034.jpeg?w=1800&q=80",
    body: "Baltic amber has been traded out of Latvia for over four thousand years. The Amber Road began at the mouth of the Daugava in what is now Riga and reached south to the Adriatic. Tutankhamun was buried with Baltic amber. Roman matrons paid more for a single bead than for a slave. The trade still runs today through the cobblestone amber market in Old Riga.",
  },
  {
    eyebrow: "The Folk Patterns",
    title: "Geometry older than writing.",
    image: "https://images.unsplash.com/photo-1572853566597-b83cde546912?w=1800&q=80",
    body: "Latvian folk patterns — woven into linen, carved into wood, painted onto pottery — are a written language that pre-dates writing. The Auseklis is the morning star, a symbol of protection. Laima is the goddess of fate. Each pattern is a small prayer, repeated until it becomes the cloth itself.",
  },
  {
    eyebrow: "Jāņi",
    title: "The longest night of the year.",
    image: "https://images.unsplash.com/photo-1571840513222-9b0b655c0198?w=1800&q=80",
    body: "On June 23rd, Latvia stops. Bonfires are lit on every hill. Oak-leaf crowns are made for the men, wildflower crowns for the women. Linen comes out of the cupboards. The Līgo songs are sung from dusk until the sun rises. It is the oldest celebration in the country, older than Christianity by thousands of years.",
  },
  {
    eyebrow: "Linen",
    title: "A national fabric.",
    image: "https://images.unsplash.com/photo-1747396206869-75ea57b325ce?w=1800&q=80",
    body: "Flax has been grown in Latvia since the Iron Age. In late June the fields turn pale blue for one week. Then the slow work begins — pulling, retting, scutching, hackling, spinning, weaving. A single dress can take months from seed to seam. It is the opposite of fast.",
  },
  {
    eyebrow: "Riga",
    title: "Eight hundred years of trade.",
    image: "https://images.pexels.com/photos/37526831/pexels-photo-37526831.jpeg?w=1800&q=80",
    body: "Riga was founded in 1201 as a Hanseatic trading post. Its medieval Old Town is a UNESCO World Heritage Site — Gothic spires, Art Nouveau facades, narrow cobblestone streets. We walk those streets to choose our amber, sitting with families who have been in the trade for three or four generations.",
  },
];

export default function LatviaPage() {
  return (
    <div data-testid="latvia-page" className="bg-cream">
      <section className="relative h-[70vh] min-h-[480px] overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: "url(https://images.pexels.com/photos/37526831/pexels-photo-37526831.jpeg?w=2000&q=80)" }}
        />
        <div className="absolute inset-0 bg-espresso/40" />
        <div className="relative h-full br-container flex items-end pb-20">
          <div className="text-cream max-w-3xl br-fade-in">
            <div className="text-[11px] uppercase tracking-[0.4em] text-amber mb-6">The Land Behind BalticRoots</div>
            <h1 className="font-serif text-5xl md:text-7xl leading-[1.05]">Latvia.</h1>
            <p className="mt-6 text-lg font-light text-cream/85 max-w-xl">
              The eastern shore of the Baltic Sea. Pine forest, white sand, amber and linen.
            </p>
          </div>
        </div>
      </section>

      <section className="py-24 md:py-32 space-y-32">
        {SECTIONS.map((s, i) => (
          <div key={s.eyebrow} className={`br-container grid md:grid-cols-12 gap-10 md:gap-16 items-center ${i % 2 === 1 ? "md:flex-row-reverse" : ""}`} data-testid={`latvia-section-${i}`}>
            <div className={`md:col-span-7 br-fade-in ${i % 2 === 1 ? "md:order-2" : ""}`}>
              <img src={s.image} alt={s.title} className="w-full aspect-[5/4] object-cover" />
            </div>
            <div className={`md:col-span-5 br-fade-in ${i % 2 === 1 ? "md:order-1" : ""}`}>
              <div className="br-eyebrow mb-4">{s.eyebrow}</div>
              <h2 className="font-serif text-3xl md:text-4xl text-espresso leading-tight mb-6">{s.title}</h2>
              <p className="text-base font-light text-dark-walnut leading-relaxed">{s.body}</p>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}
